import type { FunctionComponent } from 'react';
import { useEffect } from 'react';

import { initShopifyBuyButton } from './ShopifyButton.js';

export interface MerchandiseIf {
    className?: string;
}

export const MerchandiseIf: FunctionComponent<MerchandiseIf> = () => {
    useEffect(() => {
        initShopifyBuyButton();
    }, []);

    return (
        <>
            <div id="collection-component-1678306158670"></div>
        </>
    );
};
